export default "__VITE_ASSET__f86604a9__"